export default function Tcpa() {
  return (
    <label htmlFor="leadid_tcpa_disclosure">
      <input type="hidden" id="leadid_tcpa_disclosure" />
      <span className="inline-block pt-4 text-[10px] sm:text-xs text-gray-500 leading-snug tcpa-text">
        By submitting, you authorize top10homeservices and up to{' '}
        <a
          href="/four-home-improvement-companies"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          four home improvement companies
        </a>{' '}
        to make marketing calls and texts to the phone number provided to
        discuss your home improvement project. You understand some may use
        auto-dialers, SMS messages, artificial and prerecorded voice messages to
        contact you, even if your number is a mobile number or is currently
        listed on any state, federal or corporate Do Not Call list. There is no
        requirement to purchase services. Consent may be revoked at any time.
        Please see our{' '}
        <a
          href="/policy"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Privacy Notice
        </a>{' '}
        and{' '}
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms of Use
        </a>
        .
      </span>
    </label>
  );
}
